"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockMitekDecision = void 0;
var mockMitekDecision_1 = require("./mockMitekDecision");
Object.defineProperty(exports, "mockMitekDecision", { enumerable: true, get: function () { return mockMitekDecision_1.mockMitekDecision; } });
//# sourceMappingURL=index.js.map